import { transparentize } from "../../utils/color2k";
import { BORDER, DARK_GRAYSCALE, ELEVATION } from "./colors";
import { DANGER, WARNING, SUCCESS, BRAND } from "../colors";
import type { ProtonStyleSheet } from "../types";

export const DARK_STYLESHEET: ProtonStyleSheet = {
  // Control/component colors
  "--proton-control__background-color": DARK_GRAYSCALE.DARK,
  "--proton-control__background-color-light": ELEVATION,
  "--proton-control__text-color": DARK_GRAYSCALE.WHITE,
  "--proton-control__title-color": "#FFFFFF",
  "--proton-control__border-color": BORDER,
  "--proton-control__hover-color": DARK_GRAYSCALE.MEDIUM,
  "--proton-control__shadow-color": transparentize(
    DARK_GRAYSCALE.LIGHTEST,
    0.5
  ),
  "--proton-control__border-radius": "4px",
  "--proton-control__interactive-color": BRAND.PRIMARY_LIGHT,

  // Brand colors
  "--proton-color__primary": BRAND.PRIMARY,
  "--proton-color__primary-light": BRAND.PRIMARY_LIGHT,
  "--proton-color__primary-super-light": BRAND.PRIMARY_SUPER_LIGHT,
  "--proton-color__secondary": BRAND.SECONDARY,
  "--proton-color__secondary-light": BRAND.SECONDARY_LIGHT,
  "--proton-color__secondary-super-light": BRAND.SECONDARY_SUPER_LIGHT,

  // Semantic colors
  "--proton-color__danger-super-dark": DANGER.SUPER_DARK,
  "--proton-color__danger-dark": DANGER.DARK,
  "--proton-color__danger-medium": DANGER.MEDIUM,
  "--proton-color__danger-light": DANGER.LIGHT,
  "--proton-color__danger-super-light": DANGER.SUPER_LIGHT,
  "--proton-color__warning-dark": WARNING.DARK,
  "--proton-color__warning-medium": WARNING.MEDIUM,
  "--proton-color__warning-light": WARNING.LIGHT,
  "--proton-color__warning-super-light": WARNING.SUPER_LIGHT,
  "--proton-color__success-dark": SUCCESS.DARK,
  "--proton-color__success-medium": SUCCESS.MEDIUM,
  "--proton-color__success-light": SUCCESS.LIGHT,
  "--proton-color__success-super-light": SUCCESS.SUPER_LIGHT,

  // Grayscale colors
  "--proton-color__gray-super-dark": DARK_GRAYSCALE.SUPER_DARK,
  "--proton-color__gray-dark": DARK_GRAYSCALE.DARK,
  "--proton-color__gray-medium": DARK_GRAYSCALE.MEDIUM,
  "--proton-color__gray-medium-light": DARK_GRAYSCALE.MEDIUM_LIGHT,
  "--proton-color__gray-light": DARK_GRAYSCALE.LIGHT,
  "--proton-color__gray-lightest": DARK_GRAYSCALE.LIGHTEST,
  "--proton-color__gray-super-light": DARK_GRAYSCALE.SUPER_LIGHT,
  "--proton-color__white": DARK_GRAYSCALE.WHITE,
};
